import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext();

const STORAGE_KEY = "lang";
const SUPPORTED_LANGS = ["fr", "en"];
const DEFAULT_LANG = "fr";

const getInitialLang = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return SUPPORTED_LANGS.includes(stored) ? stored : DEFAULT_LANG;
  } catch {
    // localStorage indisponible (navigation privée, cookies bloqués)
    return DEFAULT_LANG;
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    // Garde l'attribut lang du document aligné : les lecteurs d'écran s'en
    // servent pour choisir la bonne prononciation.
    document.documentElement.lang = lang;
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // localStorage indisponible
    }
  }, [lang]);

  const toggleLanguage = () =>
    setLang((current) => (current === "fr" ? "en" : "fr"));

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
